export const getDefaultValues = (appSrctionDetails) => ({
  ApplicationSectionLable: appSrctionDetails?.ApplicationSectionLable || '',
  ApplicationSectionKeyOrder: appSrctionDetails?.ApplicationSectionKeyOrder || '',
  ApplicationSectionBackgroundImage: appSrctionDetails?.ApplicationSectionBackgroundImage,
  ApplicationSectionBackgroundImageDark: appSrctionDetails?.ApplicationSectionBackgroundImageDark,
  ApplicationSectionBackgroundVoice: appSrctionDetails?.ApplicationSectionBackgroundVoice,
  ApplicationSectionBackgroundVoiceDark: appSrctionDetails?.ApplicationSectionBackgroundVoiceDark,
  ApplicationSectionTextColor: appSrctionDetails?.ApplicationSectionTextColor,
  ApplicationSectionTextColorDark: appSrctionDetails?.ApplicationSectionTextColorDark,
  ApplicationSectionStatus: appSrctionDetails?.ApplicationSectionStatus ? true : false,
  ApplicationSectionBackgroundRepeat: appSrctionDetails?.ApplicationSectionBackgroundRepeat ? true : false,
});
